<template>
    <div class="chart-page" ref="chartPage">
        <v-row>
            <v-col cols="4" sm="4" class="paddintp0"></v-col>
            <v-col cols="4" sm="4" class="paddintp0">
                <div class="chart-top-btn">
                    <v-btn
                        @click="getChartData(true)"
                        class="sub-btn"
                        :class="chartDataType == 'subjectwise' ? 'active' : ''"
                        outlined
                    >Subjectwise</v-btn>
                    <v-btn
                        @click="getChartData(false)"
                        :class="chartDataType == 'overall' ? 'active' : ''"
                        class="sub-btn"
                        outlined
                    >Overall</v-btn>
                </div>
            </v-col>
            <!-- <v-col cols="4" sm="4" class="paddintp0">
                <div class="chart-top-btn-how">
                    <v-btn @click="howItWorks" class="how-sub-btn" outlined>How This Works</v-btn>
                </div>
            </v-col> -->
        </v-row>
        <v-row>
            <v-col cols="12" sm="12" class="paddintp0">
                <div
                    v-if="scoreData.length > 0"
                    class="d-flex overflow-x-auto justify-center"
                    :style="{ width: chartWidth}"
                >
                    <div v-for="(score, idx) in scoreData" :key="idx">
                        <BarChart :seriesData="score.series" :chartOptions="score.chartOptions" />
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12" class="paddintp0-1">
                <div class="chart-indicator">
                    <div class="indicator-block">
                        <div class="indicator-color your-marks"></div>
                        <div class="indicator-text">Your Marks</div>
                    </div>
                    <div class="indicator-block">
                        <div class="indicator-color average-marks"></div>
                        <div class="indicator-text">Batch Average Marks</div>
                    </div>
                    <div class="indicator-block">
                        <div class="indicator-color batch-high"></div>
                        <div class="indicator-text">Batch Highest Marks</div>
                    </div>
                    <div class="indicator-block">
                        <div class="indicator-color institute-avg-marks"></div>
                        <div class="indicator-text">Institute Average Marks</div>
                    </div>
                    <div class="indicator-block">
                        <div class="indicator-color institute-high"></div>
                        <div class="indicator-text">Institute Highest Marks</div>
                    </div>
                    <div class="indicator-block">
                        <div class="indicator-color all-india-high"></div>
                        <div class="indicator-text">All India Highest Marks</div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
        />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

import BarChart from "@/components/Charts/BarChart.vue";
export default {
    name: "CompareYourScore",
    components: {
        BarChart
    },
    props: ["studentId"],
    mounted() {
        this.setWidth();
        this.getChartData(true);
    },
    data() {
        return {
            cComponent: "",
            alertBoxData: {},
            status: false,
            modalwidth: "70%",
            scoreData: [],
            chartWidth: "",
            series: [
                { data: [0] },
                { data: [0] },
                { data: [0] },
                { data: [0] },
                { data: [0] },
                { data: [0] }
            ],
            chartOptions: {
                chart: {
                    type: "bar",
                    height: 350,
                    width: 300,
                    toolbar: {
                        show: false
                    }
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        distributed: false,
                        columnWidth: "70",
                        dataLabels: {
                            position: "top"
                        }
                    }
                },
                legend: {
                    show: false
                },
                fill: {
                    colors: [
                        "#869fe2",
                        "#ffbc80",
                        "#ff7373",
                        "#96ea96",
                        "#ffef73",
                        "#d796ea"
                    ]
                },
                dataLabels: {
                    offsetY: 15,
                    style: {
                        fontSize: "11px",
                        colors: ["#000"]
                    }
                },
                yaxis: {
                    show: false
                },
                grid: {
                    show: false
                },
                stroke: {
                    show: true,
                    width: 3,
                    colors: ["#fff"]
                },
                xaxis: {
                    categories: [""],
                    labels: {
                        show: false
                    },
                    axisBorder: {
                        show: true,
                        color: "#78909C",
                        height: 2,
                        width: "100%",
                        offsetX: 0,
                        offsetY: 1
                    },
                    axisTicks: {
                        show: false
                    },
                    title: {
                        text: "",
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: undefined,
                            fontSize: "12px",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            fontWeight: 600,
                            cssClass: "apexcharts-xaxis-title"
                        }
                    }
                }
            },
            chartDataType: "subjectwise"
        };
    },
    methods: {
        ...mapActions({
            getScoreData: "resultStore/getScoreData"
        }),
        howItWorks() {
            this.cComponent = "components/student/HowItWorks";
            this.alertBoxData = {
                image: this.TESTWISEANALYSIS_TEST_TYPES.COMPARESCORE
            };
            this.modalwidth = "70%";
            this.status = true;
            this.$forceUpdate();
        },
        onClose(data) {
            this.status = data.status;
        },
        setWidth() {
            let width = this.$refs.chartPage.clientWidth;
            return width;
        },
        getChartData(is_subject_wise) {
            this.chartDataType = is_subject_wise ? "subjectwise" : "overall";
            let studentTestId = this.$route.params.student_test_id;
            this.$root.showLoader = true;
            let postData = {
                student_test_id: studentTestId,
                is_subject_wise,
                student_id: this.studentId
            };
            this.getScoreData(postData)
                .then(response => {
                    this.$root.showLoader = false;
                    this.processScoreData(response);
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        processScoreData(response) {
            let scoreData = [];
            response.forEach(subject => {
                let scoreObj = {};
                let chartOptions = _.cloneDeep(this.chartOptions);
                let series = [];
                let scores = subject;
                scoreObj.subjectName = subject.title;
                chartOptions.xaxis.categories = [subject.title];
                chartOptions.xaxis.title.text = subject.title;
                series.push({ name: "Your Marks", data: [scores.total_marks.toFixed(2)] });
                series.push({
                    name: "Batch Average Marks",
                    data: [scores.avg_batch_mark.toFixed(2)]
                });
                series.push({
                    name: "Batch Highest Marks",
                    data: [scores.highest_batch_mark.toFixed(2)]
                });
                series.push({
                    name: "Institute Average Marks",
                    data: [scores.avg_institute_mark.toFixed(2)]
                });
                series.push({
                    name: "Institute Highest Marks",
                    data: [scores.highest_institute_mark.toFixed(2)]
                });
                series.push({
                    name: "All India Highes Marks",
                    data: [scores.highest_all_india_mark.toFixed(2)]
                });
                scoreObj.series = series;
                scoreObj.chartOptions = chartOptions;
                scoreData.push(scoreObj);
            });
            this.scoreData = scoreData;
        },
        getChartData1(dataType) {
            if (dataType == "overall") {
                let overAllData = [
                    { data: [61] },
                    { data: [65] },
                    { data: [66] },
                    { data: [64] },
                    { data: [71] },
                    { data: [35] }
                ];
                this.series = overAllData;
                // // let chartOptions = _.cloneDeep(this.chartOptions);
                // this.chartOptions.yaxis[0].show = true;
                // // this.chartOptions = chartOptions;
            } else {
                let subjectwiseData = [
                    { data: [61] },
                    { data: [45] },
                    { data: [76] },
                    { data: [84] },
                    { data: [61] },
                    { data: [45] }
                ];
                this.series = subjectwiseData;
            }
        }
    }
};
</script>